<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="pa-5" style="height: 100vh">
      <div>
        <v-row class="d-flex align-center justify-center">
          <v-img max-height="25px" max-width="180px" contain src="https://swiset.com/wp-content/uploads/2018/07/Swiset_Imagotipo_RGB_Black.png"/>
        </v-row>
        <p class="d-flex justify-center mt-3 mb-12 text-center" v-html="$t('title')"/>
        <v-carousel  :show-arrows="false" hide-delimiter-background hide-delimiters height="35vh" cycle>
          <v-carousel-item v-for="(feature, i) in features" :key="i">
            <v-sheet width="100%" :color="'rgba(0,0,0,0)'" tile>
              <v-row align="center" justify="center">
                <v-img :src="feature.src" position="center center" max-width="170" contain/>
                <h4 class="text-center mb-0" style="color: #111111; width: 80%;" v-html="feature.description"/>
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
        <p class="d-flex text-center mt-12" v-html="$t('subtitle')"/>
      </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "OpenOnDesktop",
  data() {
    return {
      features: [
        { src: 'https://swiset.com/wp-content/uploads/2021/06/beneficios-07.png', description: this.$t('features.insights') },
        { src: 'https://swiset.com/wp-content/uploads/2021/06/mejora-tu-trading-04.png', description: this.$t('features.journal') },
        { src: 'https://swiset.com/wp-content/uploads/2021/04/landing-03.png', description: this.$t('features.tournaments') },
        { src: 'https://swiset.com/wp-content/uploads/2021/06/beneficios-09.png', description: this.$t('features.community') },
        { src: 'https://swiset.com/wp-content/uploads/2021/06/preguntas-05.png', description: this.$t('features.telegram') },
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
    },
    goToWebsite() {
      window.open('https://swiset.com');
    }
  },
}
</script>

<i18n>
{
  "en": {
    "successfullyCreatedAccount": "Account was successfully created!\nPlease verify your email (See inbox).",
    "title": "Take full advantage by opening<br>Swiset on your desktop / laptop",
    "subtitle": "We will wait for you at app.swiset.com on your laptop or desktop.",
    "features": {
      "insights": "Get insights from your activity, through analysis with Artificial Intelligence.",
      "journal": "Automatically connect your platform and keep records on a 100% cloud journal.",
      "tournaments": "Participate in tournaments to win great awards brought by our partners.",
      "community": "Interact in trading communities, be part of streaming and compare your performance.",
      "telegram": "Link Telegram and get all the vital information about your activity and plan."
    },
    "btnGo": "But, visit our website »"
  },
  "es": {
    "successfullyCreatedAccount": "¡Tú cuenta fue satisfactoriamente creada!\nPor favor verifica tu email (Mira tú bandeja de entrada).",
    "title": "Para sacarle todo el provecho debes<br>abrir Swiset en un computador / laptop",
    "subtitle": "Te esperamos en app.swiset.com, búscalo en tu computador más cercano",
    "features": {
      "insights": "Recibe insights de tú operativa, a través de análisis con Inteligencia Artificial.",
      "journal": "Conecta automáticamente tu plataforma y lleva una bitácora 100% cloud.",
      "tournaments": "Participa en torneos para ganar grandes premios traídos por nuestros partners.",
      "community": "Interactúa en comunidades de trading, sé parte de streamings y compara tu performance.",
      "telegram": "Vincula Telegram y recibe toda la información vital sobre tu operativa y plan."
    },
    "btnGo": "Visita nuestro website »"
  }
}
</i18n>

<style scoped>

</style>
